export const getBaseUrl = () => {
  if (typeof window !== "undefined") {
    return window.location.origin;
  }
  if (process.env.VERCEL_ENV === "production") {
    return (
      `https://${process.env.VERCEL_PROJECT_PRODUCTION_URL}` || "https://dashboard.commsor.com"
    );
  }
  // custom domain for dev
  if (process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF === "dev") {
    return "https://internal.commsor.dev";
  }
  if (process.env.NEXT_PUBLIC_VERCEL_BRANCH_URL) {
    return `https://${process.env.NEXT_PUBLIC_VERCEL_BRANCH_URL}`;
  }
  if (process.env.VERCEL_URL) {
    return `https://${process.env.VERCEL_URL}`;
  }
  if (process.env.NEXT_PUBLIC_BASE_URL) {
    return process.env.NEXT_PUBLIC_BASE_URL;
  }
  return "http://localhost:3000";
};
